<div class="book book-{{ book.id }}">
  <header [queryParams]="bookLink ? { book_title:book.title, book:book.kicker}: {}"  [routerLink]="bookLink ? bookLink + '/article/'+book.id : './article/'+book.id">
    <div class="book__header__inner">
      <h2>{{ book.kicker }}</h2>
      <div>{{ book.title }}</div>
      <div class="book__documents" *ngIf="book.files.length">
        <span class="bullet">{{ book.numFiles }}</span>
      </div>
    </div>
  </header>

  <div class="book__tabs" *ngIf="hasTabs">
    <div class="book__tabs__tab" [ngClass]="{'is-active': tab == 'chapter'}" (click)="setTab('chapter')">{{'Chapters' | transloco}}</div>
    <div class="book__tabs__tab" [ngClass]="{'is-active': tab == 'appendix'}" (click)="setTab('appendix')">{{'Appendixes' | transloco}}</div>
  </div>

  <div class="book__sections book__chapters" *ngIf="tab == 'chapter'">
    <ul>
      <li *ngFor="let item of book.chapters">
        <a [queryParams]="bookLink ? {book: item.kicker, book_title:item.title}: {}"  [routerLink]="bookLink ? bookLink + '/article/'+item.id : './article/'+item.id">{{ item.kicker }} - {{ item.title }}</a>
      </li>
    </ul>
  </div>

  <div class="book__sections book__appendixes" *ngIf="tab == 'appendix'">
    <ul>
      <li *ngFor="let item of book.appendixes | slice:0:numberOfSlicesAppendix">
        <a [queryParams]="bookLink ? {book: item.kicker, book_title:item.title}: {}" [routerLink]="bookLink ? bookLink + '/article/'+item.id : './article/'+item.id">{{ item.kicker }} - {{ item.title }}</a>
      </li>
    </ul>
    <div class="book__more" *ngIf="book.appendixes.length > numberOfSlicesAppendix">
      <a (click)="increaseAppendixSlice()">{{'rulebook.more_appendixes' | transloco}}</a>
    </div>
  </div>
</div>
